__turbopack_context__.v({
  "activeContent": "UtX3oG_activeContent",
  "item": "UtX3oG_item" + " " + "header-menu-item",
  "list": "UtX3oG_list",
  "menu": "UtX3oG_menu",
  "menuContent": "UtX3oG_menuContent",
  "viewport": "UtX3oG_viewport",
});
